
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./home/bootstrap.min');
require('./home/jquery-3.7.1.min');
require('./home/bootstrap.min');
require('./home/validator.min');
require('./home/jquery.slicknav');
require('./home/swiper-bundle.min');
require('./home/jquery.waypoints.min');
require('./home/jquery.counterup.min');
require('./home/jquery.magnific-popup.min');
require('./home/SmoothScroll');
require('./home/gsap.min');
require('./home/SplitText');
require('./home/ScrollTrigger.min');
// require('./home/wow.min');
require('./home/function');
require('./home/index');
